import { defineAsyncComponent } from "vue";

// Komponenten LAZY registrieren: der Glob liefert Import-Funktionen (kein eager),
// jede Komponente wird von Vite als eigener Async-Chunk gebaut und erst geladen,
// wenn sie auf der Seite tatsächlich vorkommt. Damit landen seiten-spezifische/
// schwere Komponenten (z.B. Map → maplibre, WebGL → three) NICHT mehr im Haupt-
// Bundle → deutlich kleineres Bundle + schnellerer Vue-Mount/FCP (v.a. Behandlungsseiten).
const components = import.meta.glob("../components/**/*.vue");

export default {
    install(app) {
        Object.entries(components).forEach(([path, loader]) => {
            const componentName = path
                .split("/")
                .pop()
                .replace(/\.\w+$/, "");
            app.component(componentName, defineAsyncComponent(loader));
        });
    },
};
